"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetUrl = void 0;
exports.getTargetUrl = function (target, link, title) {
    switch (target) {
        case 'facebook':
            return "https://www.facebook.com/sharer/sharer.php?u=" + link + "&quote=Kijk \"" + title + "\" op www.kijk.nl";
        case 'twitter':
            return "https://twitter.com/intent/tweet?url=" + link;
        case 'linkedin':
            return "https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Furl%3D" + link;
        case 'pinterest':
            return "https://www.pinterest.com/pin/create/button/?url=" + link;
        case 'email':
            return "mailto:?subject=&body=" + link;
        default:
            return '';
    }
};
